const countKPIs = (initiative) => {
    if (!initiative || !initiative.KPI || !Array.isArray(initiative.KPI)) {
      return 0;
    }
    return initiative.KPI.length;
  };
  
  export default countKPIs;